import styled from 'styled-components';
import { respondTo } from 'assets/styled/breakpoints';
import { Field, Form } from 'formik';
import { COLORS } from 'assets/styled';
import CustomSelect from 'components/Select/FormikSelect';

export const ButtonContainer = styled.div`
  width: 100%;
`;

export const StyledForm = styled(Form)`
  max-width: 580rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 20rem;
  margin-bottom: 5rem;

  ${respondTo.smallTablet`
    flex-direction: column;
    gap: 10rem;
  `}
`;

export const FieldWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const FieldLabel = styled.span`
  font-size: 14rem;
  font-weight: 600;
  color: ${COLORS.BLACK};
`;

export const StyledCustomSelect = styled(CustomSelect)`
  margin-top: 5rem;
  width: 100%;
  max-width: 50%;
  padding-right: 10rem;

  ${respondTo.smallTablet`
    max-width: 100%;
    padding-right: 0;
  `}
`;
